"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgElevatedIcon = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 18, height: 16, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "m17.702 12.718-6.76-11.631a2.224 2.224 0 0 0-.82-.796 2.274 2.274 0 0 0-2.228 0c-.34.19-.622.465-.82.796L.298 12.718a2.158 2.158 0 0 0 .002 2.19c.196.333.477.609.817.8.339.192.724.293 1.115.292h13.536c.391 0 .776-.1 1.115-.291.34-.192.621-.468.817-.801a2.157 2.157 0 0 0 .002-2.19Z", fill: "#FFBC17" }), (0, jsx_runtime_1.jsx)("path", { d: "M9 5.363a.78.78 0 0 0-.547.223.753.753 0 0 0-.226.537v3.799c0 .201.081.394.226.537a.78.78 0 0 0 1.094 0 .753.753 0 0 0 .227-.537V6.123a.753.753 0 0 0-.227-.537A.78.78 0 0 0 9 5.363ZM9 12.96c.427 0 .774-.34.774-.759 0-.42-.347-.76-.774-.76a.767.767 0 0 0-.773.76c0 .42.346.76.773.76Z", fill: "#fff" })] }))); };
exports.default = SvgElevatedIcon;
